import React from 'react';
import { NumericFormat } from 'react-number-format-5';
import { Input } from '@THC/components/Input';
export const InputNumericFormat = (props) => {
    const { formProps } = props;
    const { onChange } = formProps?.input || {};
    const defaultOnValueChange = ({ formattedValue }) => {
        onChange?.({ target: { value: formattedValue } });
    };
    const { allowNegative = false, fixedDecimalScale = true, onValueChange = defaultOnValueChange, thousandSeparator = ',', ...restProps } = props;
    return (<Input {...{ allowNegative, fixedDecimalScale, onValueChange, thousandSeparator }} {...restProps} as={NumericFormat} withRef={false}/>);
};
